import React, { Component } from 'react';
import Spin from '../../../components/loading';
import { connect } from 'react-redux';
import { Line, Pie } from 'react-chartjs-2';
import { withRouter, Link } from 'react-router-dom';
import { formatter } from '../../../utils';
import * as dashbaordActions from '../../../redux/dashboard/actions';
import 'chartjs-plugin-datalabels';
import '../dashboard.scss';

class Dashboard extends Component {
  componentDidMount() {
    this.props.fetchAllDashbaordData();
  }

  renderHeaderCards() {
    let {
      averageDirectPrice,
      totalActivatedCafes,
      totalRequestedCafes,
      totalRseeTablesPercent,
      averageReservationPrice,
      averagePurePrice,
      totalSuspendedReservations,
      totalActiveCafeChairs
    } = this.props.dashboardData;

    return (
      <>
        <div className="row">
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--green">
              <div className="dashboard-card__body">
                <h6>{locales('titles.pureWagesAveragePerReserve')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(averagePurePrice)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('tables.toman')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--purple">
              <div className="dashboard-card__body">
                <h6>{locales('titles.averageCostOfOrderPerReserve')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(averageReservationPrice)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('tables.toman')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--orange">
              <div className="dashboard-card__body">
                <h6>{locales('titles.directReserveCostsAverage')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(averageDirectPrice)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('tables.toman')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card">
              <div className="dashboard-card__body">
                <h6>{locales('total.rsee.tables.percent')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(totalRseeTablesPercent)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('labels.percent')}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--green">
              <div className="dashboard-card__body">
                <h6>{locales('titles.activeCafesCount')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(totalActivatedCafes)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('labels.count.unit')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--purple">
              <div className="dashboard-card__body">
                <h6>{locales('titles.requestedCafesCount')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(totalRequestedCafes)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('labels.count.unit')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card dashboard-card--orange">
              <div className="dashboard-card__body">
                <h6>{locales('titles.totalSuspendedReservations')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(totalSuspendedReservations)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('labels.count.unit')}</span>
                </h4>
              </div>
            </div>
          </div>
          <div className="col-xl-3 col-lg-6 col-md-12">
            <div className="dashboard-card">
              <div className="dashboard-card__body">
                <h6>{locales('titles.activeCafesChairCount')}</h6>
                <h4>
                  <span className="dashboard-card__number-amount">
                    {formatter.numberWithCommas(totalActiveCafeChairs)}
                  </span>
                  <span className="dashboard-card__number-unit">{locales('labels.count.unit')}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }

  renderMainChart() {
    return (
      <div className="col d-flex">
        <div className="w-75">
          <Line
            data={{
              labels: ['فروردین', 'اردیبهشت', 'خرداد', 'تیر', 'مرداد', 'شهریور'],
              datasets: [
                {
                  cubicInterpolationMode: 'monotone',
                  fill: true,
                  label: 'از کل کاربران',
                  data: [12, 19, 3, 5, 2, 3],
                  backgroundColor: ['#541C70'],
                  borderColor: [
                    'red',
                    'blue',
                    'rgba(255, 206, 86, 1)',
                    'rgba(75, 192, 192, 1)',
                    'rgba(153, 102, 255, 1)',
                    'rgba(255, 159, 64, 1)'
                  ],
                  borderWidth: 1,
                  type: 'line',
                  options: {
                    scales: {
                      yAxes: [
                        {
                          ticks: {
                            beginAtZero: true
                          }
                        }
                      ]
                    }
                  }
                }
              ]
            }}
            options={{
              legend: { display: true },
              scales: {
                yAxes: [
                  {
                    ticks: {
                      beginAtZero: true
                    }
                  }
                ]
              }
            }}
          />
        </div>
        <div className="text-center justify-content-around pb-3 d-flex flex-column w-25">
          <div className="font-large font-weight-bold border-bottom">
            {locales('titles.progressStatistics')}
          </div>
          <div>
            <div className="p-3">
              <div className="col d-flex justify-content-start">
                {locales('titles.instagramProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-75" />
              </div>
            </div>
            <div className="p-3">
              <div className="col  d-flex justify-content-start">
                {locales('titles.twitterProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-50" />
              </div>
            </div>
            <div className="p-3">
              <div className="col d-flex justify-content-start">
                {locales('titles.applicationProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-25" />
              </div>
            </div>
            <div className="p-3">
              <div className="col d-flex justify-content-start">
                {locales('titles.telegramProgressStatistics')}
              </div>
              <div className="progress">
                <div className="progress-bar bg-info w-75" />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  renderOtherCharts() {
    let {
      totalCanceledReservations,
      totalCanceledReservationsInPercent,
      totalClientDoNotCameReservations,
      totalClientDoNotCameReservationsInPercent,
      totalReservations,

      totalActivatedUsers,
      totalActivatedUsersInPercent,
      totalUsers,

      averageRseePurePriceInPercent,
    } = this.props.dashboardData;
    return (
      <div className="col d-flex justify-content-center">
        <div className="d-flex">
          <div className="w-100 mx-2 card">
            <div className="card-body">
              <div className="w-100 d-flex justify-content-center align-items-start border-bottom">
                <div className="w-50 border-left">
                  <Pie
                    data={{
                      labels: [locales('titles.cancelationPercentageFromClient')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [
                            totalCanceledReservationsInPercent,
                            Number((100 - totalCanceledReservationsInPercent).toFixed(2))
                          ],
                          backgroundColor: ['red', '#DDD'],
                          borderColor: ['red', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales(
                              'titles.cancelationsCount'
                            )} : ${totalCanceledReservations} \n ${locales(
                              'titles.reservationsCount'
                            )} : ${totalReservations}`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          font: { size: 18, family: 'Vazir' },
                          color: 'white',
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />

                  <div className="p-3 text-center">
                    {locales('titles.reservationsCount')} : {totalReservations || 0}
                  </div>
                  <div className="p-3 text-center">
                    {locales('titles.cancelationsCount')} : {totalCanceledReservations || 0}
                  </div>
                </div>

                <div className="w-50 border-left">
                  <Pie
                    data={{
                      labels: [locales('titles.clientDoNotCamePercentage')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [
                            totalClientDoNotCameReservationsInPercent,
                            Number((100 - totalClientDoNotCameReservationsInPercent).toFixed(2))
                          ],
                          backgroundColor: ['red', '#DDD'],
                          borderColor: ['red', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales(
                              'titles.clientDoNotCameCount'
                            )} : ${totalClientDoNotCameReservations} \n ${locales(
                              'titles.reservationsCount'
                            )} : ${totalReservations}`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          font: { size: 18, family: 'Vazir' },
                          color: 'white',
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />

                  <div className="p-3 text-center">
                    {locales('titles.reservationsCount')} : {totalReservations || 0}
                  </div>
                  <div className="p-3 text-center">
                    {locales('titles.clientDoNotCameCount')} : {totalClientDoNotCameReservations || 0}
                  </div>
                </div>

              </div>

              <div className="w-100 d-flex justify-content-center align-items-start">
                <div className="w-50 border-left">
                  <Pie
                    data={{
                      labels: [locales('titles.activeUsers')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [
                            totalActivatedUsersInPercent,
                            Number((100 - totalActivatedUsersInPercent).toFixed(2))
                          ],
                          backgroundColor: ['blue', '#DDD'],
                          borderColor: ['blue', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales('titles.activeUsersCount')} : ${totalActivatedUsers}`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          color: 'white',
                          font: { size: 18, family: 'Vazir' },
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />
                  <div className="p-3 text-center">
                    {locales('titles.totalUsersCount')} : {totalUsers}
                  </div>
                  <div className="p-3 text-center">
                    {`${locales('titles.activeUsersCount')} : ${totalActivatedUsers}`}
                  </div>
                </div>

                <div className="w-50">
                  <Pie
                    data={{
                      labels: [locales('titles.RseePureWagesPercentage')],
                      datasets: [
                        {
                          cubicInterpolationMode: 'monotone',
                          fill: true,
                          label: 'zxczxc',
                          data: [
                            averageRseePurePriceInPercent,
                            Number((100 - averageRseePurePriceInPercent).toFixed(2))
                          ],
                          backgroundColor: ['green', '#DDD'],
                          borderColor: ['green', '#DDD'],
                          borderWidth: 1
                        }
                      ]
                    }}
                    width={200}
                    height={200}
                    options={{
                      tooltips: {
                        rtl: true,
                        bodyFontFamily: 'Vazir',
                        bodyFontSize: 12,
                        titleFontFamily: 'Vazir',
                        titleFontSize: 12,
                        caretSize: 20,
                        bodyAlign: 'right',
                        titleAlign: 'right',
                        footerAlign: 'right',
                        callbacks: {
                          label: (tooltipItem, data) => {
                            const value = data.datasets[0].data[tooltipItem.index];
                            return value + '%';
                          },
                          title: (tooltipItem, data) => {
                            return data.labels[tooltipItem[0].index];
                          },
                          afterLabel: (tooltipItem, data) =>
                            `${locales('titles.RseePureWagesPercentage')} : 30`
                        }
                      },
                      plugins: {
                        datalabels: {
                          display: true,
                          font: { size: 18, family: 'Vazir' },
                          color: 'white',
                          textAlign: 'center',
                          labels: {
                            title: {
                              font: {
                                weight: 'bold'
                              }
                            },
                            value: {
                              clip: true,
                              color: 'green'
                            }
                          }
                        }
                      },

                      legend: {
                        labels: {
                          fontSize: 14,
                          fontFamily: 'Vazir'
                        },
                        display: true
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    let { dashboardDataLoading, dashboardDataError, dashboardDataMessage, dashboardDataFailed } = this.props;

    return (
      <div className="col p-0 m-0">
        <Spin spinning={dashboardDataLoading}>
          {dashboardDataError && <div className="alert alert-danger">{locales('messages.server.error')}</div>}

          {dashboardDataFailed && <div className="alert alert-danger">{dashboardDataMessage}</div>}

          <div className="col p-3">{this.renderHeaderCards()}</div>
          {/* <div className="col">{this.renderMainChart()}</div> */}
          <div className="col p-3">{this.renderOtherCharts()}</div>
          <Link target="_blank" to="/dashboard/guide">
            <div className="m-4">
              <span>{locales('titles.dashboardGuide')}</span>{' '}
              <span className="font-weight-bold text-danger">{locales('titles.here')}</span>{' '}
              <span>{locales('titles.click')}</span>
            </div>
          </Link>
        </Spin>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    dashboardDataLoading: state.dashboardReducer.dashboardDataLoading,
    dashboardDataFailed: state.dashboardReducer.dashboardDataFailed,
    dashboardDataError: state.dashboardReducer.dashboardDataError,
    dashboardDataMessage: state.dashboardReducer.dashboardDataMessage,
    dashboardData: state.dashboardReducer.dashboardData
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllDashbaordData: () => dispatch(dashbaordActions.fetchAllDashbaordData())
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Dashboard));
